module.exports = __webpack_public_path__ + "img/add-photo-fifth-icon.ea56d601.svg";